<template>
  <div>
    <WebsiteHeader></WebsiteHeader>

    <v-content>
      <slot></slot>
    </v-content>

    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";

export default {
  components: { WebsiteHeader, WebsiteFooter },

  computed: {
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    }
  },
  data() {
    return {
      snColor: "",
      snackbar: false,
      loginMsg: ""
    };
  },
  methods: {
    signOut() {
      axios
        .postDataWithToken("/auth/logout", {}, this.getAccessToken)
        .then(response => {
          this.$store.commit("setAuthenticated", false);
          this.$store.commit("setCurrentUser", {});
          this.$store.commit("setCurrentStudent", {});

          if (response.loggedOut) {
            this.snackbar = true;
            this.snColor = this.getThemeColor;
            this.loginMsg = "Logged Out Successfully!";
          }
        });
    }
  }
};
</script>